import logo from '../../logo.svg';

export default function SignupSuccess() {
  return (
    <>
      <div className="flex min-h-full flex-1 items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
        <div className="w-full max-w-sm space-y-10">
          <div>
            <img
              className="mx-auto h-16 w-auto"
              src={logo}
              alt="RÖEN"
            />
            <h2 className="mt-4 text-center text-4xl font-bold leading-9 tracking-tight text-gray-900">
              ¡Bienvenido!
            </h2>
          </div>

          <div className="space-y-6">
            <img src="https://files.roenpro.com/account_created.png" alt="successful signup"/>

            <p className="-my-3 text-center text-sm leading-6 text-gray-600">
              ¡Nos da mucho gusto que seas parte de RÖEN!
            </p>
            <p className="-my-3 text-center text-sm leading-6 text-gray-600">
              <a href="/" className="font-semibold text-indigo-600 hover:text-indigo-500">Inicia sesión</a> para acceder a la plataforma 
              ó <a target="_blank" rel="noreferrer" href="https://api.whatsapp.com/send/?phone=5213334523607&text&type=phone_number&app_absent=0" className="font-semibold text-indigo-600 hover:text-indigo-500">solicita</a> una asesoría gratuita para sacarle el mayor provecho a RÖEN.
            </p>
          </div>

          <div>
        <a
                            href="https://api.whatsapp.com/send/?phone=5213334523607&text&type=phone_number&app_absent=0"
                            target="_blank"
                            rel="noreferrer"
                            className="group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50 hover:text-indigo-600"
                          >
                            <img
                              className="w-28 shrink-0 text-gray-400 group-hover:text-indigo-600"
                              src="https://static.whatsapp.net/rsrc.php/yZ/r/JvsnINJ2CZv.svg"
                              alt='WhatsApp'
                            />
                          </a>
        </div>
        </div>
      </div>
    </>
  )
};
